// ===== LUCIDE =====
import {
  Mail,
  MapPin,
  MessageCircle,
  Leaf,
  Clock,
  User,
  BarChart,
  Calendar,
  ChevronRight,
  Heart,
  Lock,
  ArrowRight,
  X,

  // About / Stats
  UsersRound,
  Target,
  Award,

  // BenefitsSection
  UserRound,
  ClipboardCheck,
  Flower2,
  Goal,
  HandHeart,
  Sparkles,
  Check,
  Star,
  ShieldCheck,
  Sofa,
  Camera,
  BadgeCheck,
  // ClinicSection
  Armchair,
  RotateCcw,
  HeartHandshake,

} from "lucide-react";

// ===== REACT ICONS =====
import { FaInstagram, FaWhatsapp } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";

// ===== ÍCONES CUSTOMIZADOS =====
function UserHeart() {
  return (
    <span className="icon-composed icon-composed--user-heart" aria-hidden="true">
      <UserRound className="icon-composed__main" />
      <Heart className="icon-composed__badge" />
    </span>
  );
}

function Tour360() {
  return (
    <span className="icon-tour-360" aria-hidden="true">
      360°
    </span>
  );
}

/// ===== EXPORT CENTRALIZADO =====
export const Icons = {
  // lucide base
  Mail,
  MapPin,
  MessageCircle,
  Leaf,
  Clock,
  User,
  BarChart,
  Calendar,
  ChevronRight,
  Heart,
  Lock,
  ArrowRight,
  X,
  ShieldCheck,
  Sofa,
  Camera,
  BadgeCheck,
  UserRound,
  ClipboardCheck,
  Flower2,
  Goal,
  HandHeart,
  Sparkles,
  Check,
  Star,
  Armchair,
  RotateCcw,

  UsersRound,
  Target,
  Award,
  HeartHandshake,

  // custom
  UserHeart,
  Tour360,

  // react-icons
  FaInstagram,
  FaWhatsapp,
  FcGoogle,
  
};